import { render, staticRenderFns } from "./GamepadButton.vue?vue&type=template&id=5fb99989&"
import script from "./GamepadButton.vue?vue&type=script&lang=js&"
export * from "./GamepadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports